import React, { Component, Fragment } from "react";
import { Link, withRouter,Redirect } from "react-router-dom";
import ReactDOM from 'react-dom';
import Modal from 'react-responsive-modal';
import api from "../../../services/api"



class Map extends Component {
  
    state = {
        open: false,
        idfatura:"",
        error:"",
        toreload:false,
        valorinteiro:"",
        valordesconto:"",
        valorpago:"",
        diavencimento:"",
        oldstatus:"",
        status:"",
        transaction_id:"",
        idmatricula:"",
        tentativa:0,
        formapag:"0",
        oldformapag:"",
        datapagamento:"",
        otherwisebullet:false

      };
     
      onOpenModal = () => {
        this.setState({ open: true });
      };
     
      onCloseModal = () => {
        this.setState({ open: false,error:"" });
        this.setState({ 
          idmatricula:"",
          valorinteiro:"",
          valordesconto:"",
          valorpago:"",
          diavencimento:"",
          status:"",
          formapag:"",
          oldformapag:"0",
          oldstatus:""
        })
        
       
      };
      componentWillUpdate(nextProps, nextState)
      {

        if(nextState.formapag!==this.state.formapag || nextState.status!==this.state.status ){
          if(nextState.formapag==0 ){
         


            this.setState({ otherwisebullet: true });
          }
          else if(nextState.formapag!==0 && nextState.status==0){
            this.setState({ otherwisebullet: true });
          
          }
          else if(nextState.formapag!==0 && nextState.status==1){
            this.setState({ otherwisebullet: true });
          
          }
  
          else if(nextState.formapag!==0 && nextState.status==2){
            this.setState({ otherwisebullet: false,
            datapagamento:new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2) });
          }
          else if(nextState.formapag!==0 && nextState.status==3){
            this.setState({ otherwisebullet: false,
            datapagamento:new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2) });
          }
        }
        
      }

      componentWillReceiveProps(nextProps){
        
        if(nextProps.truemodaledit!==this.state.truemodaledit){
          if(nextProps.truemodaledit!==""){
            this.setState({ open: true,
              idfatura:nextProps.truemodaledit });
              this.loadfatura();
          }
        }


        

       
      }
       
    
      async loadfatura(){
       

        
        const response1 = await api.post("/admin/fatura",{id:this.state.idfatura});

      
        
        this.setState({ 
          idmatricula:response1.data.idmatricula,
          valorinteiro:response1.data.valorinteiro,
          valordesconto:response1.data.valordesconto,
          valorpago:response1.data.valorpago,
          diavencimento:response1.data.diavencimento,
          status:response1.data.status,
          oldstatus:response1.data.status,
          formapag:response1.data.formapag,
          oldformapag:response1.data.formapag,
          datapagamento:response1.data.datapagamento
        })


        if(this.state.formapag==0 ){
         


          this.setState({ otherwisebullet: true });
        }
        else if(this.state.formapag!==0 && this.state.status==0){
          this.setState({ otherwisebullet: true });
        
        }
        else if(this.state.formapag!==0 && this.state.status==1){
          this.setState({ otherwisebullet: true });
        
        }

        else if(this.state.formapag!==0 && this.state.status==2){
          this.setState({ otherwisebullet: false,
          datapagamento:new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2) });
        }
        else if(this.state.formapag!==0 && this.state.status==3){
          this.setState({ otherwisebullet: false,
          datapagamento:new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2) });
        }

      }

  
      

      editfatura = async e => {
        e.preventDefault();
        this.setState({ error: "",
        success:null });





        const {valorpago,datapagamento,otherwisebullet, oldstatus,oldformapag,formapag,idfatura, valordesconto, idmatricula, valorinteiro, status, diavencimento } = this.state;
        if(formapag==0 && datapagamento!==""){
          this.setState({ datapagamento:"",
          success:null,datapagamento:"", valorpago:"",
          success:null });
        }

          if (!idfatura || !valorinteiro 
              || !diavencimento || !idmatricula) {
              this.setState({ error: "Preencha os dados antes de editar!",
            success:null });
              
          }
          else if(formapag==0 && oldformapag!==formapag && status==2){
            this.setState({ error: "Você não pode atualizar fatura paga com boleto. Contate o administrador",
            success:null });
          }
          else if(formapag==0 && status==2 && oldstatus!==status){
            this.setState({ error: "Você não pode atualizar fatura paga com boleto. Contate o administrador",
            success:null });
          }
          
          else {


          


          const response = await api.post("/admin/fatura/edit", {
            formapag,id:idfatura, idmatricula, valordesconto, valorinteiro, status, diavencimento,
            valorpago,datapagamento,
           });
    
            if(response.data.id){
              this.setState({ success: "Fatura Editada!" , error:null,
             });

             window.location.replace("/admin/faturas/"+idmatricula);
            }else{
              this.setState({ success: null , error:response.data.error,
             });
            }
    
          }
      }
    

      
      


render() {

    const { open } = this.state;


return (
    <React.Fragment>

<div class="sizemodal ">
        <Modal class="col-xl"  open={open} onClose={this.onCloseModal} center>
       <div class="row text-center">
         
          <div class="col-lg-10">
          <h5>Fatura ID #{this.state.idfatura}</h5>
          <div class="w-100"></div>
          </div>        
        </div>
          <div class="row">
          <div class="col-lg">
          <div class="w-100"></div>

          <form action="#" method="POST" onSubmit={this.editfatura}>


            <div class="row">

              <div class="col">
                <div class="form-group">
                  <label for="exampleInputEmail1">ID Fatura</label>
                  <input type="text" defaultValue={this.state.idfatura} readOnly class="form-control" onChange={e => this.setState({ idfatura: e.target.value })} id="exampleInputEmail1" aria-describedby="emailHelp" />
                </div>
              </div>

              <div class="col">
                <div class="form-group">
                    <label for="exampleInputEmail1">Matricula</label>
                    <input type="text" defaultValue={this.state.idmatricula} readOnly class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                </div>
              </div>
            </div>
  
  
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="exampleInputEmail1">Valor Inteiro</label>
                <input type="text" defaultValue={this.state.valorinteiro} class="form-control" onChange={e => this.setState({ valorinteiro: e.target.value })} id="exampleInputEmail1" aria-describedby="emailHelp" />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="exampleInputEmail1">Valor Desconto</label>
                <input type="text" class="form-control" defaultValue={this.state.valordesconto} onChange={e => this.setState({ valordesconto: e.target.value })} id="exampleInputEmail1" aria-describedby="emailHelp" />
              </div>
            </div>
          </div>

  

          <div class='row'>
            <div class="col">
              <div class="form-group">
                <label for="exampleInputEmail1">Valor Pago</label>
                <input type="text"required={this.state.otherwisebullet==true} disabled={this.state.otherwisebullet==true} defaultValue={this.state.valorpago} onChange={e => this.setState({ valorpago: e.target.value })}  class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="exampleInputEmail1">Data Pagamento</label>
                <input type="date" required={this.state.otherwisebullet==true} disabled={this.state.otherwisebullet==true} defaultValue={this.state.datapagamento} onChange={e => this.setState({ datapagamento: e.target.value })}  class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label for="exampleInputEmail1">Dia Vencimento</label>
                <input type="date" onChange={e => this.setState({ diavencimento: e.target.value })} defaultValue={this.state.diavencimento} class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                
              </div>
            </div>
          </div>

          <div class="form-group">
                <label for="exampleFormControlSelect1">Forma de Pagamento</label>
                <select class="form-control"  onChange={e => this.setState({ formapag: e.target.value })}>
                <option value="0" selected={this.state.formapag==0}>Boleto</option>
                <option value="1" selected={this.state.formapag==1}>Cartão de Crédito</option>
                <option value="2" selected={this.state.formapag==2}>Cartão de Debito</option>
                <option value="3" selected={this.state.formapag==3}>Cheque</option>
                <option value="4" selected={this.state.formapag==4}>Especie</option>
                <option value="5" selected={this.state.formapag==5}>Outros</option>
                </select>
          </div>


          <div class="form-group">
            <label for="exampleFormControlSelect1">Status</label>
            <select class="form-control"  onChange={e => this.setState({ status: e.target.value })}>
            <option value="0" selected={this.state.status==0}>Cancelada</option>
            <option value="1" selected={this.state.status==1}>Não Paga</option>
            <option value="2" selected={this.state.status==2}>Paga</option>
            <option value="3" selected={this.state.status==3}>Reembolsado</option>

            </select>
          </div>

  
  <button type="submit" class="btn btn-primary">Atualizar Fatura</button>
</form>
             
<center class="text-danger">{this.state.error}</center>
<center class="text-success">{this.state.success}</center>




          </div>

        </div>
       







         

        </Modal>
   
        </div>
    </React.Fragment>
)



}

}

export default withRouter(Map);


// WEBPACK FOOTER //
// ./src/pages/Admin/modulofinanceiro/modalfatura.js